import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Zoom from "@mui/material/Zoom";
import LinearProgress from "@mui/material/LinearProgress";
import IconButton from "@mui/material/IconButton";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { CirromLogoAvatar } from "../Logo";

/**
 * A loading placeholder card for record-detail style modals. Renders inside an
 * always-mounted Modal while the record data is being fetched/prepared, then is
 * swapped for the full card once the data is available.
 *
 * @param {Object} props
 * @param {string} [props.title] - Header title; defaults to the customer-data copy.
 * @param {Function} props.onClose - Called when the close button is clicked.
 * @param {string} [props.imageSrc] - Illustration source; defaults to /undraw_security.svg.
 * @param {string} [props.imageAlt] - Illustration alt text.
 * @returns {JSX.Element}
 */
export const ModalLoadingCard = (props: {
  title?: string;
  onClose: () => void;
  imageSrc?: string;
  imageAlt?: string;
}) => {
  return (
    <Zoom in={true} style={{ transitionDelay: "250ms" }}>
      <Card>
        <CardHeader
          style={{ padding: "20px" }}
          title={
            props.title ??
            "Fetching up to date customer data and decoding local information"
          }
          titleTypographyProps={{ variant: "h4" }}
          avatar={<CirromLogoAvatar />}
          action={
            <IconButton onClick={props.onClose}>
              <CloseOutlinedIcon />
            </IconButton>
          }
        />
        <LinearProgress />
        <div style={{ textAlign: "center" }}>
          <img
            src={props.imageSrc ?? "/undraw_security.svg"}
            style={{ height: "256px", padding: "20px" }}
            alt={props.imageAlt ?? "fetching-records-securely"}
          />
        </div>
      </Card>
    </Zoom>
  );
};
